import React from 'react';
import { BudgetPhases } from 'business/constants';
import { useTranslation } from 'react-i18next';
import { FUNCTION_BUDGET_PHASE_COLORS } from 'routes/BudgetModule/config/constants';
import ColoredChip from 'ui/ColoredChip/ColoredChip';
import { SxProps } from '@mui/system';

type Props = {
    phase: BudgetPhases;
    className?: string;
    sx?: SxProps;
};

const BudgetPhase = function ({
    phase,
    className = undefined,
    sx = undefined,
}: Props): React.ReactElement {
    const { t } = useTranslation();

    const backgroundColor = FUNCTION_BUDGET_PHASE_COLORS.background[phase];
    const color = FUNCTION_BUDGET_PHASE_COLORS.color[phase];

    return (
        <ColoredChip
            color={color}
            backgroundColor={backgroundColor}
            className={className}
            content={t(`budgetProposal.${phase}`)}
            sx={sx}
        />
    );
};

export default BudgetPhase;
